import React from 'react';
import Guardians from '../components/guardians';

class GuardianPageContainer extends React.Component {

  render() {
    return (
      <div className="guardians-page">
        <div className="page-container">
          <h2>My followers</h2>
          <Guardians moduleType="PAGE" {...this.props} />
        </div>
      </div>

    )
  }

}


export default GuardianPageContainer;


// WEBPACK FOOTER //
// ./src/containers/guardianPageContainer.js